<form [formGroup]="form">
    <label>{{ label }}</label>
    <div class="bciti-select bciti-select-input" (click)="toggleDropdown()" #dropreference>
      <ul>
        <li>
          <span *ngIf="selected"> {{ 'pages.userFamily.link.' + selected.toLowerCase() | translate }} </span>
          <span *ngIf="!selected" class="placeholder"> {{ placeholder }} </span>
          <span class="icon icon-caret-down"></span></li>
      </ul>
      <app-user-family-select-dropdown [reference]="dropreference" #dropdown>
        <div class="bciti-select bciti-select-dropdown no-margin">
          <ul>
            <ng-container *ngFor="let option of options">
              <li (click)="select(option)" *ngIf="option !== selected">
                {{ 'pages.userFamily.link.' + option.toLowerCase() | translate }}
              </li>
            </ng-container>
          </ul>
        </div>
      </app-user-family-select-dropdown>
    </div>
  </form>